import React, { Component } from "react";
import FileUploader from "react-firebase-file-uploader";
import { getImageDownloadURL, storageRef } from "../../services/firebase";

import { Dimmer, Loader } from "semantic-ui-react";

class FileUpload extends Component {
    state = { name: "", file: null, fileURL: "", isUploading: false };

    handleOnUploadSuccess = async (filename, uploadTask) => {
        try {
            const url = await getImageDownloadURL(this.props.storageDir, filename);

            this.props.onChange(`${url}...${filename}`);

            this.setState({ isUploading: false, name: filename, fileURL: url });
        } catch (error) {
            this.setState({ isUploading: false });
        }
    };

    onChange = ({ target: { files: [file] } = {} }) => {
        const reader = new FileReader();

        file && reader.readAsDataURL(file);

        reader.addEventListener("load", () => this.props.onChange({ file: reader.result }));
    };

    render() {
        const { isUploading, fileURL } = this.state;
        const { storageDir, avatarImage, ...input } = this.props;

        return (
            <>
                {!avatarImage ? (
                    <div className="file-upload-container">
                        {isUploading ? (
                            <Dimmer active inverted>
                                <Loader size="big" inverted />
                            </Dimmer>
                        ) : (
                            <div
                                className={`file-upload ${fileURL ? "src-pr" : ""}`}
                                style={{ background: fileURL && `url(${fileURL})` }}>
                                <FileUploader
                                    id={input.name}
                                    name={input.name}
                                    accept="image/*"
                                    randomizeFilename
                                    storageRef={storageRef(storageDir)}
                                    onUploadStart={file => this.setState({ file, isUploading: true })}
                                    onUploadError={() => this.setState({ isUploading: false })}
                                    onUploadSuccess={this.handleOnUploadSuccess}
                                />
                            </div>
                        )}
                    </div>
                ) : (
                    <input {...input} value="" onChange={this.onChange} />
                )}
            </>
        );
    }
}

export default FileUpload;

/*

handleChange = file => {
    const reader = new FileReader();

    file && reader.readAsDataURL(file);

    reader.addEventListener("load", () => this.props.onChange(reader.result));
};


handleChange = ({ target: { files: [file] } = {} }) => {
    const reader = new FileReader();

    file && reader.readAsDataURL(file);

    reader.addEventListener("load", () => this.setState({ file: reader.result }));
};

*/

/*
import React, { Component } from "react";
import FileUploader from "react-firebase-file-uploader";
import { getImageDownloadURL, storageRef } from "../../services/firebase";

import { Dimmer, Loader } from "semantic-ui-react";

class FileUpload extends Component {
    state = { name: "", file: null, fileURL: "", isUploading: false };

    handleOnUploadSuccess = async (filename, uploadTask) => {
        try {
            const url = await getImageDownloadURL(this.props.storageDir, filename);

            this.props.onChange(filename);

            this.setState({ isUploading: false, name: filename, fileURL: url });
        } catch (error) {
            this.setState({ isUploading: false });
        }
    };

    render() {
        const { isUploading, fileURL } = this.state;
        const { storageDir, ...input } = this.props;

        return (
            <div className="file-upload-container">
                {isUploading ? (
                    <Dimmer active inverted>
                        <Loader size="big" inverted />
                    </Dimmer>
                ) : (
                    <div
                        className={`file-upload ${fileURL ? "src-pr" : ""}`}
                        style={{ background: fileURL && `url(${fileURL})` }}>
                        <FileUploader
                            id={input.name}
                            name={input.name}
                            accept="image/*"
                            randomizeFilename
                            storageRef={storageRef(storageDir)}
                            onUploadStart={file => this.setState({ file, isUploading: true })}
                            onUploadError={() => this.setState({ isUploading: false })}
                            onUploadSuccess={this.handleOnUploadSuccess}
                        />
                    </div>
                )}
            </div>
        );
    }
}

export default FileUpload;
*/
